<template lang="pug">
button-base.button-primary.font-bold(@click='clickEvent')
  slot
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'

/**
 * 基本のボタン
 */
@Component({
  components: {
    ButtonBase,
  },
})
export default class ButtonPrimary extends Vue {
  private clickEvent(key: Event): void {
    this.$emit('click', key)
  }
}
</script>

<style lang="stylus" scoped>
.button-primary
  height var(--input-height-default)
  padding 10px
  color var(--color-input-primary__text)
  background-color var(--color-input-primary__background)
  border-radius 20px

  &[data-disabled='true']
    background-color var(--color-input-primary__background-disabled)
    cursor default
</style>
